import { matchPath } from "react-router-dom";
import { fetchDashboardData } from "../store/Slices/DashboardSlice";
import { fetchCustomers } from "../store/Slices/CustomerSlice";
import { fetchSuppliers } from "../store/Slices/SupplierSlice";
import { fetchProducts } from "../store/Slices/ProductSlice";
import { fetchCategories } from "../store/Slices/CategorySlice";
import { fetchSubCategories } from "../store/Slices/SubCategorySlice";
import { fetchExpenses } from "../store/Slices/ExpenseSlice";
import { fetchExpenseTypes } from "../store/Slices/ExpenseTypeSlice";
import { fetchAccounts } from "../store/Slices/AccountSlice";
import { fetchBranches } from "../store/Slices/BranchesSlice";
import { fetchLoans, fetchLoanLog } from "../store/Slices/LoanSlice";
import { fetchCustomerPayments } from "../store/Slices/CustomerPaymentSlice";
import { fetchCompanyPayments } from "../store/Slices/CompanyPaymentSlice";
import { fetchCustomerLedger } from "../store/Slices/CustomerLedgerSlice";
import { fetchCustomerItemSummary } from "../store/Slices/CustomerItemSummarySlice";
import { fetchSupplierLedger } from "../store/Slices/SupplierLedgerSlice";
import { fetchCompanyItemSummary } from "../store/Slices/CompanyItemSummarySlice";
import { fetchStockStats } from "../store/Slices/StockStatsSlice";
import { fetchCashBooks } from "../store/Slices/CashBookSlice";
import { fetchCashAdjustments } from "../store/Slices/CashAdjustmentSlice";
import { fetchLabours } from "../store/Slices/LabourSlice";
import { fetchInvestor } from "../store/Slices/InvestorSlice";
import { fetchRawMaterials } from "../store/Slices/RawMaterialSlice";
import { fetchRMStockStats } from "../store/Slices/RMStockStatsSlice";
import { fetchCustomerInvoice } from "../store/Slices/CustomerInvoiceSlice";
import { fetchCustomerReturnInvoice } from "../store/Slices/CustomerReturnInvoiceSlice";
import { fetchSupplierInvoice } from "../store/Slices/SupplierInvoiceSlice";

const dispatchAll = (dispatch, actions) => {
  actions.forEach((action) => dispatch(action));
};

const matchAdmin = (pathname, pattern) => {
  const m = matchPath({ path: pattern, end: true }, pathname);
  return m?.params || null;
};

export const runDefaultRouteRefresh = async ({ pathname, dispatch }) => {
  const admin = pathname.startsWith("/admin");
  const branch = pathname.startsWith("/branch");
  const base = admin ? "/admin" : branch ? "/branch" : null;
  if (!base) return false;

  if (pathname === base || pathname === `${base}/`) {
    dispatchAll(dispatch, [fetchDashboardData()]);
    return true;
  }

  const simpleRoutes = {
    [`${base}/customers`]: [fetchCustomers()],
    [`${base}/companies`]: [fetchSuppliers()],
    [`${base}/items`]: [fetchProducts()],
    [`${base}/categories`]: [fetchCategories()],
    [`${base}/sub-categories`]: [fetchSubCategories()],
    [`${base}/expense`]: [fetchExpenses(), fetchExpenseTypes()],
    [`${base}/accounts`]: [fetchAccounts()],
    [`${base}/branches`]: [fetchBranches()],
    [`${base}/stock-stats`]: [fetchStockStats()],
    [`${base}/raw-material-stock-stats`]: [fetchRMStockStats()],
    [`${base}/payments`]: [fetchCustomers(), fetchSuppliers()],
    [`${base}/labour`]: [fetchLabours()],
    [`${base}/investors`]: [fetchInvestor()],
    [`${base}/cash-payments`]: [fetchCashBooks()],
    [`${base}/cash-book`]: [fetchCashBooks()],
    [`${base}/customers-invoice`]: [fetchCustomers()],
    [`${base}/supplier-invoice`]: [fetchSupplierInvoice()],
    [`${base}/invoices`]: [
      fetchCustomers(),
      fetchCustomerInvoice(),
      fetchCustomerReturnInvoice(),
    ],
  };

  if (simpleRoutes[pathname]) {
    dispatchAll(dispatch, simpleRoutes[pathname]);
    return true;
  }

  if (pathname === `${base}/customers-report`) {
    dispatch(fetchCustomers());
    return true;
  }
  if (pathname === `${base}/items-report`) {
    dispatch(fetchProducts());
    return true;
  }
  if (pathname === `${base}/companies-report`) {
    dispatch(fetchSuppliers());
    return true;
  }

  if (pathname === `${base}/discount-log`) {
    return false;
  }

  params = matchAdmin(pathname, `${base}/discount-log/customer/:customerId`);
  if (params?.customerId) return false;

  params = matchAdmin(pathname, `${base}/discount-log/company/:companyId`);
  if (params?.companyId) return false;

  let params = matchAdmin(pathname, `${base}/receivables/:customerId`);
  if (params?.customerId) {
    dispatchAll(dispatch, [
      fetchCustomers(),
      fetchCustomerLedger(params.customerId),
      fetchCustomerItemSummary(params.customerId),
    ]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/payables/:companyId`);
  if (params?.companyId) {
    dispatchAll(dispatch, [
      fetchSuppliers(),
      fetchSupplierLedger(params.companyId),
      fetchCompanyItemSummary(params.companyId),
    ]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/loans/:loanId`);
  if (params?.loanId) {
    dispatchAll(dispatch, [fetchLoans(), fetchLoanLog()]);
    return true;
  }

  if (pathname === `${base}/loans`) {
    dispatchAll(dispatch, [fetchLoans(), fetchLoanLog()]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/customers-payments/:id`);
  if (params?.id) {
    dispatch(fetchCustomerPayments(params.id));
    return true;
  }

  params = matchAdmin(pathname, `${base}/company-payments/:id`);
  if (params?.id) {
    dispatch(fetchCompanyPayments(params.id));
    return true;
  }

  params = matchAdmin(pathname, `${base}/accounts/:accountId/log`);
  if (params?.accountId) {
    dispatch(fetchAccounts());
    return true;
  }

  params = matchAdmin(pathname, `${base}/customer-ledger-report/:id`);
  if (params?.id) {
    dispatchAll(dispatch, [
      fetchCustomers(),
      fetchCustomerLedger(params.id),
      fetchCustomerItemSummary(params.id),
    ]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/company-ledger-report/:id`);
  if (params?.id) {
    dispatchAll(dispatch, [
      fetchSuppliers(),
      fetchSupplierLedger(params.id),
      fetchCompanyItemSummary(params.id),
    ]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/customer-item-summary/:id`);
  if (params?.id) {
    dispatchAll(dispatch, [
      fetchCustomers(),
      fetchCustomerLedger(params.id),
      fetchCustomerItemSummary(params.id),
    ]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/company-item-summary/:id`);
  if (params?.id) {
    dispatchAll(dispatch, [
      fetchSuppliers(),
      fetchCompanyItemSummary(params.id),
    ]);
    return true;
  }

  params = matchAdmin(pathname, `${base}/finance`);
  if (params !== null || pathname === `${base}/finance`) {
    if (pathname === `${base}/finance`) {
      dispatchAll(dispatch, [
        fetchAccounts(),
        fetchCashAdjustments(),
        fetchCashBooks({}),
        fetchCustomers(),
        fetchSuppliers(),
      ]);
      return true;
    }
  }

  if (pathname === `${base}/ledger`) {
    return false;
  }

  if (pathname === `${base}/receivables` || pathname === `${base}/payables`) {
    return false;
  }

  if (
    pathname.startsWith(`${base}/report`) ||
    pathname.startsWith(`${base}/daily-report`)
  ) {
    return false;
  }

  return false;
};
